import { BUTTON_CONSTANTS } from "@/core/constants/common/button-contants";
import { ELEMENT_ID } from "@/core/constants/common/element-constants";
import FormWrapper from "@/core/wrappers/form-wrapper";
import { Form } from "devextreme-react";
import { useCallback, useRef, useState } from "react";
import Validator from 'devextreme/ui/validator';
import { INewCredential } from "@/core/interfaces/usestate-interfaces";
import { profileService } from "../../../services/profile-service";

const NewCredential = () => {
    const formRef: any = useRef<Form>();
    const [newCredential] = useState<INewCredential>({ password: '', confirmPassword: '' });
    const [password, setPassword] = useState('');

    const handleSubmit = useCallback(async (): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                const form = formRef.current.props.formData;
                await profileService.setPasswordAsync(form);
                formRef.current.instance.clear()
                resolve();
            } catch (error) {
                reject(error)
            }
        })
    }, []);

    const passwordComparison = useCallback<any>(() => password, [password]);
    const changePasswordMode = useCallback((name: any) => {
        if (formRef != null && formRef.current != null) {
            const editor = formRef.current.instance.getEditor(name);
            if (editor)
                editor.option('mode', editor.option('mode') === 'text' ? 'password' : 'text');
        }
    }, []);
    const getPasswordOptions = useCallback(() => ({
        inputAttr: { [ELEMENT_ID]: 'password', autocomplete: 'one-time-code' },
        mode: 'password',
        valueChangeEvent: 'keyup',
        onValueChanged: (e: any) => {
            setPassword(e.value);
            if (formRef != null && formRef.current != null) {
                const editor = formRef.current.instance.getEditor('confirmPassword');
                if (editor != null && editor.option('value')) {
                    const instance = Validator.getInstance(editor.element()) as Validator;
                    instance.validate();
                }
            }
        },
        buttons: [
            {
                name: 'password',
                location: 'after',
                options: {
                    stylingMode: 'text',
                    icon: 'eyeopen',
                    onClick: () => changePasswordMode('password'),
                },
            },
        ],
    }), [changePasswordMode]);

    const getConfirmOptions = useCallback(() => ({
        inputAttr: { [ELEMENT_ID]: 'passwordConfirm', autocomplete: 'one-time-code' },
        mode: 'password',
        valueChangeEvent: 'keyup',
        buttons: [
            {
                name: 'password',
                location: 'after',
                options: {
                    stylingMode: 'text',
                    icon: 'eyeopen',
                    onClick: () => changePasswordMode('confirmPassword'),
                },
            },
        ],
    }), [changePasswordMode]);

    return (
            <div className='view-wrapper'>
                <FormWrapper
                    onSubmit={handleSubmit}
                    formRef={formRef}
                    formData={newCredential}
                    isAddBackBtn={false}
                    buttonGroups={[
                        { buttonOptions: BUTTON_CONSTANTS.SaveBtn }
                    ]}
                    simpleItemGroups={[
                        {
                            useColCountByScreen: false,
                            items: [
                                {
                                    dataField: "password",
                                    editorType: "dxTextBox",
                                    editorOptions: getPasswordOptions(),
                                    label: 'password',
                                    isRequired: true,
                                    requiredMessage: 'password',
                                    pattern: "^(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&\\-_\\.])[A-Za-z\\d@$!%*?&\\-_\\.]{8,}$",
                                    patternMessage: "password_validation_message",
                                },
                                {
                                    dataField: "confirmPassword",
                                    editorType: "dxTextBox",
                                    editorOptions: getConfirmOptions(),
                                    label: 'confirm_password',
                                    isRequired: true,
                                    requiredMessage: 'confirm_password',
                                    compare: true,
                                    compareMessage: "Password and Confirm Password do not match",
                                    comparisonTarget: passwordComparison
                                },
                            ]
                        }
                    ]}
                />
            </div>
    )
}
export default NewCredential
